import React from 'react'
import './style.css'

export default function Section4() {
  return (
    <div>
      
    <div className="section2 mt-3">
        <div className="sect4-bg ">
        
      <div className="container-fluid2">
      <div className="section2__txt">
          <h1 className='sect2__h1'>WHAT WE DO?</h1>
          <p>SCOPE OF SERVICES <br />
          ••• Negotiation strategy training (including aggressive and
attacking techniques) •••  <br /> <br />
Only at first glance, any negotiations are based on the
knowledge, motivation and ability of the parties to achieve.
assigned tasks.  Most of the methods and tools for successful
negotiations have already been described in books and have
long been studied in universities.  What we offer is a technique
developed by highly qualified psychologists with implemented
elements of influence that are used by special services and
intelligence from different countries.   This model and tools
were created and adapted to the business model, successfully
tested in negotiations at various levels, and today are one of
the most successful models for achieving maximum results.  
(More details about the system and its application during a
personal consultation, subject to the signing of non-disclosure
documents)  <br /> <br />
••• HR consulting. Constructive solution of internal conflicts in
the company ••• <br /> <br />
We will help you select proven professional staff for a position
in your company. We also have extensive experience in non-
standard resolution of internal conflicts. If shareholders,
company owners, investors cannot resolve a conflict or
existing situation and this affects your business or is already
starting to cause losses, we will analyze the situation and act as
a mediator, offering standard and non-standard solutions to
get out of the situation.</p>
      </div>
      </div>
      </div>
    </div>
    </div>
  )
}
